import { forwardRef } from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'
import { placed, placedChild } from '@/lib/style-guard'

const Checkbox = forwardRef<
  React.ComponentRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => {
  placedChild(props.asChild ? props.children : null, 'Checkbox')
  return (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'hit-area peer size-5 shrink-0 rounded-[var(--radius-sm)] border border-[var(--control-border)]',
      'bg-[var(--input-bg)]',
      'transition-colors duration-[var(--duration-fast)]',
      'focus-visible:outline-none focus-ring',
      'disabled:cursor-not-allowed disabled:opacity-50',
      /* Use the action pair together in every mode. The selected border remains visible
         when a custom brand fill is close to the surrounding surface. */
      'data-[state=checked]:bg-[var(--action-primary-bg)] data-[state=checked]:border-[var(--border-selected)] data-[state=checked]:text-[var(--action-primary-text)]',
      placed(className, 'Checkbox', props)
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center">
      <Check className="size-3.5" strokeWidth={3} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
  )
})
Checkbox.displayName = 'Checkbox'

export { Checkbox }
